(() => {
  if (customElements.get('jb2-product-card')) return;
  class JB2ProductCard extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('form');
      this.select = this.querySelector('select[name="id"]');
      this.button = this.querySelector('button[type="submit"]');
      this.label = this.querySelector('[data-add-text]');
      this.message = this.querySelector('[data-message]');
      this.querySelector('[data-swatches]')?.removeAttribute('hidden');
      this.select.addEventListener('change', () => this.updateVariant());
      this.querySelectorAll('[data-variant]').forEach((button) => {
        button.addEventListener('click', () => {
          this.select.value = button.dataset.variant;
          this.updateVariant();
        });
      });
      this.form.addEventListener('submit', (event) => this.addToCart(event));
      this.updateVariant();
    }
    updateVariant() {
      this.variant = this.variants.find((variant) => String(variant.id) === this.select.value);
      if (!this.variant) { this.button.disabled = true; return; }
      this.querySelector('[data-price]').innerHTML = this.variant.priceHtml;
      this.querySelector('[data-product-link]').href = this.variant.url;
      const image = this.querySelector('.jb2l-card__image');
      if (image && this.variant.image && image.src !== this.variant.image) {
        image.removeAttribute('srcset');
        image.src = this.variant.image;
        image.alt = this.variant.alt;
      }
      this.querySelectorAll('[data-variant]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.variant === this.select.value));
      });
      this.button.disabled = this.busy || !this.variant.available;
      this.label.textContent = this.busy ? this.dataset.addingLabel : this.variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      this.message.textContent = '';
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.variant?.available) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.label.textContent = this.dataset.addingLabel;
      this.message.textContent = '';
      this.message.classList.remove('is-error');
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(this.form)
        });
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || item.message || this.dataset.errorLabel);
        this.message.textContent = this.dataset.addedLabel;
        this.querySelector('[data-cart-link]').hidden = false;
        this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item, addToCartBtn: this.button } }));
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((result) => result.ok ? result.json() : null)
          .then((cart) => {
            if (!cart) return;
            window.dispatchEvent(new CustomEvent('11six24:cart-updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          }).catch(() => {});
      } catch (error) {
        this.message.textContent = error.message || this.dataset.errorLabel;
        this.message.classList.add('is-error');
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.button.disabled = !this.variant.available;
        this.label.textContent = this.variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }
    }
  }
  customElements.define('jb2-product-card', JB2ProductCard);
})();
